import { paths } from '../routing/Router/paths';

export const getViewPageLabel = (path = '') =>
  Object.keys(paths)[Object.values(paths).indexOf(path as any)];
